
import { computed, defineComponent, onBeforeUnmount, onMounted, PropType, ref } from 'vue'
import { MarketplaceTrialOffer, trialFreeCaption, trialPeriodLabel } from '../trialOffers'

export default defineComponent({
    name: 'TrialOfferModal',
    props: {
        offer: { type: Object as PropType<MarketplaceTrialOffer>, required: true },
        activating: { type: Boolean, default: false },
    },
    emits: ['close', 'activate'],
    setup(props, { emit }) {
        const host = ref<HTMLElement | null>(null)
        const periodLabel = computed(() => trialPeriodLabel(props.offer.days))
        const freeCaption = computed(() => trialFreeCaption(props.offer.days))
        const close = () => emit('close')
        const activate = () => emit('activate')
        const onKeydown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') close()
        }
        onMounted(() => {
            const el = host.value
            if (el && el.parentNode !== document.body) {
                document.body.appendChild(el)
            }
            document.addEventListener('keydown', onKeydown)
        })
        onBeforeUnmount(() => {
            document.removeEventListener('keydown', onKeydown)
        })
        return { host, periodLabel, freeCaption, close, activate }
    },
})
